import React, {PropsWithChildren} from 'react';
import {observer} from "mobx-react";
import {VideoSlideFooterLayoutBox} from './boxes/video-slide-footer-layout.box';
import {GameInfo} from '../../../services/games/game-info';
import {useServices} from '../../../react-hooks/use-services.hook';
import {VideoSlideGameTitleLayoutBox} from './boxes/standard-video-slide-footer-game-title/video-slide-footer-game-title-layout.box';
import {Button} from '../../../basic-ui-components/button/base/button.component';

interface StandardVideoSlideFooterProps extends PropsWithChildren {
    gameInfo: GameInfo;
    secondaryText: React.ReactElement;
}
export const VideoSlideFooterLayoutComponent: React.FC<StandardVideoSlideFooterProps> = observer((props) => {
    const services = useServices();
    const tableInfo = services.liveTableFeeds.getTableInfo(props.gameInfo.gameType);
    const _renderGameTitle = () => {

        let title = props.gameInfo?.title || "\xa0";

        if (tableInfo?.Name?.length > 0) {
            title = tableInfo.Name;
        }

        return (
            <VideoSlideGameTitleLayoutBox>
                {title}
            </VideoSlideGameTitleLayoutBox>
        );
    }

    return (
        <VideoSlideFooterLayoutBox>
            {_renderGameTitle()}
            {props.secondaryText}
            <Button
                preset="primary"
                sizeVariant="xs"
                onClick={() => {props.gameInfo.open({isRealMode: true})}}
            >
                {services.translation.translate("PLAY_NOW")}
            </Button>
        </VideoSlideFooterLayoutBox>
    )
})